import { render, staticRenderFns } from "./TPRFollowListItem.vue?vue&type=template&id=408c817a&scoped=true"
import script from "./TPRFollowListItem.vue?vue&type=script&lang=js"
export * from "./TPRFollowListItem.vue?vue&type=script&lang=js"
import style0 from "./TPRFollowListItem.vue?vue&type=style&index=0&id=408c817a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c817a",
  null
  
)

export default component.exports